import {
  Box,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  ArrowDownward,
  ArrowUpward,
  CopyAll,
  Delete,
  SwapVert as SwapVertIcon,
} from "@mui/icons-material";
import "./style.css";
import { roles } from "../../../constants/routes";
import Button from "../../common/Button";
import { useState } from "react";

export const columns = ({
  selectedIds,
  handleSelect,
  handleSelectAll,
  handleStatusChange,
  setSortBy,
  setIsDescending,
  isDescending,
  setOpenView,
  setContentPreview,
  approved,
  schedule,
  setStatusContent,
  statusContent,
  primaryColor,
  setCurrentPage,
  role,
  onDelete,
  onDuplicate,
  sortBy,
}) => {
  const ActionCell = ({ row }) => {
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openDuplicateModal, setOpenDuplicateModal] = useState(false);

    const handleDelete = () => {
      onDelete(row.original.id);
      setOpenDeleteModal(false);
    };

    const handleDuplicate = () => {
      onDuplicate(row.original.id);
      setOpenDuplicateModal(false);
    };

    return (
      <>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            // gap: 1,
            minWidth: "90px",
            flexWrap: "nowrap",
            justifyContent: "flex-start",
          }}
        >
          <Button
            onClick={() => {
              setOpenView(true);
              setContentPreview(row.original);
            }}
            backgroundColor="white"
            endIcon={<VisibilityIcon fontSize="small" color={primaryColor} />}
            style={{
              minWidth: "20px",
              padding: "2px",
              border: "none",
              backgroundColor: "transparent",
              "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
            }}
          />
          <Button
            onClick={() => setOpenDeleteModal(true)}
            backgroundColor="white"
            endIcon={<Delete fontSize="small" color={primaryColor} />}
            style={{
              minWidth: "20px",
              padding: "2px",
              border: "none",
              backgroundColor: "transparent",
              "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
            }}
          />
          <Button
            onClick={() => setOpenDuplicateModal(true)}
            backgroundColor="white"
            endIcon={<CopyAll fontSize="small" color={primaryColor} />}
            style={{
              minWidth: "20px",
              padding: "2px",
              border: "none",
              backgroundColor: "transparent",
              "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
            }}
          />
        </Box>

        {/* Delete Confirmation Modal */}
        <Dialog
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
        >
          <DialogTitle>
            <Typography>Confirm Delete</Typography>
          </DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to delete this article?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setOpenDeleteModal(false)}
              text="Cancel"
              backgroundColor="white"
            />
            <Button onClick={handleDelete} text="Delete" />
          </DialogActions>
        </Dialog>

        <Dialog
          open={openDuplicateModal}
          onClose={() => setOpenDuplicateModal(false)}
        >
          <DialogTitle>
            <Typography>Confirm Duplicate</Typography>
          </DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to duplicate this article?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setOpenDuplicateModal(false)}
              text="Cancel"
              backgroundColor="white"
            />
            <Button onClick={handleDuplicate} text="Duplicate" />
          </DialogActions>
        </Dialog>
      </>
    );
  };

  return [
    {
      accessorKey: "article",
      header: ({ table }) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Checkbox
            indeterminate={table.getIsSomeRowsSelected()}
            checked={table.getIsSomeRowsSelected().length === 10}
            onChange={() => handleSelectAll()}
            style={{ color: "white" }}
          />

          <div
            onClick={() => {
              setSortBy("Article");
              setIsDescending(!isDescending);
            }}
            style={{ display: "flex", alignItems: "center" }}
          >
            <Typography variant="body2">Article</Typography>
            {sortBy === "Article" ? (
              isDescending == false ? (
                <ArrowUpward style={{ fontSize: "1rem", cursor: "pointer" }} />
              ) : (
                <ArrowDownward
                  style={{ fontSize: "1rem", cursor: "pointer" }}
                />
              )
            ) : (
              <SwapVertIcon style={{ fontSize: "1rem", cursor: "pointer" }} />
            )}{" "}
          </div>
        </div>
      ),
      cell: ({ row, value }) => (
        <>
          <Checkbox
            checked={selectedIds.includes(row.original.id)}
            onChange={() => handleSelect(row.original.id)}
          />

          <Tooltip title={row.original.article} arrow placement="top">
            <Box
              component="span"
              sx={{
                marginLeft: 1,
              }}
            >
              {row.original.article}
            </Box>
          </Tooltip>
        </>
      ),
    },
    {
      accessorKey: "topic",
      header: ({ table }) => (
        <div
          style={{ display: "flex", alignItems: "center" }}
          onClick={() => {
            setSortBy("Topic");
            setIsDescending(!isDescending);
          }}
        >
          <Typography variant="body2">Topic</Typography>
          {sortBy === "Topic" ? (
            isDescending == false ? (
              <ArrowUpward style={{ fontSize: "1rem", cursor: "pointer" }} />
            ) : (
              <ArrowDownward style={{ fontSize: "1rem", cursor: "pointer" }} />
            )
          ) : (
            <SwapVertIcon style={{ fontSize: "1rem", cursor: "pointer" }} />
          )}{" "}
        </div>
      ),
    },
    {
      accessorKey: "author",
      header: ({ table }) => (
        <div
          style={{ display: "flex", alignItems: "center" }}
          onClick={() => {
            setSortBy("Author");
            setIsDescending(!isDescending);
          }}
        >
          <Typography variant="body2">Author</Typography>
          {sortBy === "Author" ? (
            isDescending == false ? (
              <ArrowUpward style={{ fontSize: "1rem", cursor: "pointer" }} />
            ) : (
              <ArrowDownward style={{ fontSize: "1rem", cursor: "pointer" }} />
            )
          ) : (
            <SwapVertIcon style={{ fontSize: "1rem", cursor: "pointer" }} />
          )}{" "}
        </div>
      ),
    },
    {
      accessorKey: "dateCreated",
      header: ({ table }) => (
        <div
          style={{ display: "flex", alignItems: "center" }}
          onClick={() => {
            setSortBy("DateCreated");
            setIsDescending(!isDescending);
          }}
        >
          <Typography variant="body2">Date Created</Typography>
          {sortBy === "DateCreated" ? (
            isDescending == false ? (
              <ArrowUpward style={{ fontSize: "1rem", cursor: "pointer" }} />
            ) : (
              <ArrowDownward style={{ fontSize: "1rem", cursor: "pointer" }} />
            )
          ) : (
            <SwapVertIcon style={{ fontSize: "1rem", cursor: "pointer" }} />
          )}{" "}
        </div>
      ),
      cell: ({ row }) => (
        <>
          <Box component="span" sx={{ marginLeft: 1 }}>
            {dayjs(row.original.dateCreated).format("DD/MM/YYYY")}
          </Box>
        </>
      ),
    },
    {
      accessorKey: "scheduledDate",
      header: ({ table }) => (
        <div
          style={{ display: "flex", alignItems: "center" }}
          onClick={() => {
            setSortBy("scheduledDate");
            setIsDescending(!isDescending);
          }}
        >
          <Typography variant="body2">Date Scheduled</Typography>
          {sortBy === "scheduledDate" ? (
            isDescending == false ? (
              <ArrowUpward style={{ fontSize: "1rem", cursor: "pointer" }} />
            ) : (
              <ArrowDownward style={{ fontSize: "1rem", cursor: "pointer" }} />
            )
          ) : (
            <SwapVertIcon style={{ fontSize: "1rem", cursor: "pointer" }} />
          )}{" "}
        </div>
      ),
      cell: ({ row }) => (
        <>
          <Box component="span" sx={{ marginLeft: 1 }}>
            {dayjs(row.original.scheduledDate).format("DD/MM/YYYY HH:mm")}{" "}
          </Box>
        </>
      ),
    },
    {
      accessorKey: "featured",
      header: ({ table }) => (
        <div
          style={{ display: "flex", alignItems: "center" }}
          onClick={() => {
            setSortBy("featured");
            setIsDescending(!isDescending);
          }}
        >
          <Typography variant="body2">Featured</Typography>
          {sortBy === "featured" ? (
            isDescending == false ? (
              <ArrowUpward style={{ fontSize: "1rem", cursor: "pointer" }} />
            ) : (
              <ArrowDownward style={{ fontSize: "1rem", cursor: "pointer" }} />
            )
          ) : (
            <SwapVertIcon style={{ fontSize: "1rem", cursor: "pointer" }} />
          )}{" "}
        </div>
      ),
      cell: ({ row }) => (
        <>
          <Box component="span" sx={{ marginLeft: 1 }}>
            {row.original.featured ? "Yes" : "No"}
          </Box>
        </>
      ),
    },
    {
      accessorKey: "status",
      size: 120, // Set column width
      minSize: 120,
      header: ({ table }) => {
        const statusOptions = [
          { label: "All", value: null },
          { label: "Pending", value: 0 },
          { label: "Approved", value: 1 },
          { label: "Rejected", value: 3 },
          { label: "Archived", value: 4 },
        ];

        const handleFilterChange = (event) => {
          const selectedStatus = event.target.value;
          setStatusContent(selectedStatus);
          setCurrentPage(1);
        };

        return approved || schedule ? (
          <div
            style={{ display: "flex", alignItems: "center" }}
            onClick={() => {
              setSortBy("DateCreated");
              setIsDescending(!isDescending);
            }}
          >
            <Typography variant="body2">Status</Typography>
            <SwapVertIcon style={{ cursor: "pointer" }} />
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Select
              value={statusContent}
              onChange={handleFilterChange}
              sx={{
                minWidth: 120,
                width: 120, // Fixed width
                backgroundColor: "black",
                color: "white",
                borderRadius: "24px",
                fontSize: "0.9rem",

                "& .MuiSelect-icon": {
                  color: "white",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white",
                },
              }}
              displayEmpty
              renderValue={(selected) => {
                if (selected === null) return "All";
                const option = statusOptions.find(
                  (opt) => opt.value === selected
                );
                return option ? option.label : "All";
              }}
            >
              {statusOptions.map((option) => (
                <MenuItem key={String(option.value)} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </div>
        );
      },
      cell: ({ row }) => (
        <Box sx={{ minWidth: 140, overflow: "visible" }}>
          {roles.ContentCreator === role ? (
            <Typography>{row.original.status}</Typography>
          ) : (
            <Select
              value={row.original.status}
              onChange={(event) =>
                handleStatusChange(row.original.id, event.target.value)
              }
              sx={{
                minWidth: 120,
                width: 120, // Fixed width to prevent truncation
              }}
              style={{
                border: "2px solid",
                borderColor:
                  row.original.status === "Pending"
                    ? "orange"
                    : row.original.status === "Approved"
                    ? primaryColor
                    : "red",
                borderRadius: "24px",
              }}
            >
              {row.original.status === "Pending" && (
                <MenuItem style={{ backgroundColor: "none" }} value="Pending">
                  Pending
                </MenuItem>
              )}
              <MenuItem style={{ backgroundColor: "none" }} value="Approved">
                Approved
              </MenuItem>
              <MenuItem style={{ backgroundColor: "none" }} value="Rejected">
                Rejected
              </MenuItem>
              {row.original.status === "Archived" && (
                <MenuItem style={{ backgroundColor: "none" }} value="Archived">
                  Archived
                </MenuItem>
              )}
            </Select>
          )}
        </Box>
      ),
    },
    {
      id: "actions",
      header: "Actions",
      cell: ActionCell,
      style: {
        overflow: "visible",
      },
    },
  ];
};
